// API 에러 타입
export class ApiError extends Error {
    /** HTTP 응답 상태 코드 (axios interceptor에서 주입). 0 = 네트워크/알 수 없음 */
    public status?: number;

    constructor(
        public errorCode: number,
        public title?: string,
        message?: string
    ) {
        super(message || title || 'API Error');
        this.name = 'ApiError';
    }
}